
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Header',
  setup() {
    // NOTE: local時はdebug用に.env.localから値注入
    const CHANNEL_NAME =
      process.env.NODE_ENV === 'local' ? window.CHANNEL_NAME || process.env.VUE_APP_CHANNEL_NAME : window.CHANNEL_NAME;
    const CHANNEL_PICTURE_URL =
      process.env.NODE_ENV === 'local'
        ? window.CHANNEL_PICTURE_URL || process.env.VUE_APP_CHANNEL_PICTURE_URL
        : window.CHANNEL_PICTURE_URL;

    return {
      CHANNEL_NAME,
      CHANNEL_PICTURE_URL,
    };
  },
});
